<template>
<div class="rich-text-editor">
  <editor :id="customId || id" class="mc-editor" v-model="content" :init="defaultOptions"
    @onBlur="onBlur"
    @onInit="onInit"
    @onKeyDown="onKeyDown"
    @onClick="onClick"
    @onPaste="onPaste"
    @onDrop="onDrop"/>
  <span class="number-word-tip">
    <span :class="{ 'out-of-limit': (maxChars > 0 && characterCount > maxChars) }">
      {{ characterCount }}
    </span>
    <span v-if="maxChars > 0">
      / {{ maxChars }}
    </span>
  </span>
  <el-dialog
    class="img-upload-dialog"
    title="添加图片"
    :visible.sync="isShowImgUpload"
    width="459px"
    top="203px"
    custom-class="dialog"
    append-to-body = "true"
    :show-close="false">
    <i class="icon-close" @click="cancelImageUpload" />
    <span class="dialog-tip">提示：从素材中上传jpg、png、gif类型图片，上传大小不超过2M。</span>
    <div slot="footer">
      <!-- <el-upload
        class="upload-demo" ref="imgUpload"
        :show-file-list="false" :action="ossAction"
        accept="image/jpeg, image/png, image/gif"
        :before-upload="beforeImageUpload"
        :http-request="uploadFile"
        :on-success="handleImgUploadSuccess"
        :on-change="handleImgChange"
        multiple>
        <el-button class="dialog-select" type="primary">选择图片</el-button>
      </el-upload> -->
      <el-button class="dialog-select"  @click="showMaterialImageSelector = true" type="primary">选择图片</el-button>
    </div>
  </el-dialog>
  <material-selector v-if="showMaterialImageSelector"
                      type="picture"
                      :visible="showMaterialImageSelector"
                      :accept="['jpg', 'jpeg', 'png', 'gif']"
                      @close="handleMaterialImageSelectorClose"
                      @confirm-select="handleConfirmImageSelect"></material-selector>
  <el-dialog
    class="video-upload-dialog"
    title="添加视频"
    :visible.sync="isShowVideoUpload"
    width="459px"
    top="203px"
    custom-class="dialog"
    append-to-body = "true"
    :show-close="false">
    <i class="icon-close" @click="cancelVideoUpload" />
    <span class="dialog-tip">提示：从素材中上传视频，上传大小不超过{{ limit.videoMaxSize }}M。</span>
    <div slot="footer">
      <!-- <el-upload
        class="upload-demo" ref="videoUpload"
        :show-file-list="false" :action="ossAction"
        accept="video/*"
        :before-upload="beforeVideoUpload"
        :http-request="uploadFile"
        :on-success="handleVideoUploadSuccess">
        <el-button class="dialog-select" type="primary">选择视频</el-button>
      </el-upload> -->
      <el-button class="dialog-select" @click="showMaterialVideoSelector = true" type="primary">选择视频</el-button>
    </div>
  </el-dialog>
  <material-selector v-if="showMaterialVideoSelector"
                      type="video"
                      :visible="showMaterialVideoSelector"
                      :accept="['mp4', 'mov', 'avi', '3pg', 'rmvb', 'flv']"
                      @close="handleMaterialVideoSelectorClose"
                      @confirm-select="handleConfirmVideoSelect"></material-selector>
  <el-dialog
    class="file-upload-dialog"
    title="添加文件"
    :visible.sync="isShowFileUpload"
    width="459px"
    top="203px"
    custom-class="dialog"
    append-to-body = "true"
    :show-close="false">
    <i class="icon-close" @click="cancelFileUpload" />
    <span class="dialog-tip">提示：文件上传大小不超过{{ limit.fileMaxSize }}M。</span>
    <div slot="footer">
      <!-- <el-upload
        class="upload-demo" ref="fileUpload"
        :show-file-list="false" :action="ossAction"
        :before-upload="beforeFileUpload"
        :http-request="uploadFile"
        :on-success="handleFileUploadSuccess">
        <el-button class="dialog-select" type="primary">选择文件</el-button>
      </el-upload> -->
      <el-button class="dialog-select" @click="showMaterialFileSelector = true" type="primary">选择文件</el-button>
    </div>
  </el-dialog>
  <material-selector v-if="showMaterialFileSelector"
                      type="*"
                      :visible="showMaterialFileSelector"
                      :accept="['*']"
                      @close="handleMaterialFileSelectorClose"
                      @confirm-select="handleConfirmFileSelect"></material-selector>
  <el-dialog
    width="459px"
    top="203px"
    custom-class="dialog add-link-dialog"
    :title="addLinkDialogTitle"
    :visible.sync="isShowAddLink"
    :show-close="false"
    :close-on-click-modal="false"
    append-to-body = "true"
    @closed="afterCloseAddLinkDialog">
    <i class="icon-close" @click="closeAddLinkDialog" />
    <el-form ref="linkForm" :model="link" :rules="linkFormRules">
      <el-form-item prop="text">
        <el-input class="link-text" v-model="link.text" placeholder="输入链接文本"></el-input>
      </el-form-item>
      <el-form-item prop="address">
        <el-input class="link-address" v-model="link.address" type="textarea" :rows="3" placeholder="输入链接地址"></el-input>
      </el-form-item>
      <el-form-item prop="visitLimit" class="visit-limit">
        <span class="visit-limit-label">登录后才能访问</span>
        <el-radio v-model="link.visitLimit" :label="true">是</el-radio>
        <el-radio v-model="link.visitLimit" :label="false">否</el-radio>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button class="dialog-select" type="primary" @click="handleAddLink">确认</el-button>
    </div>
  </el-dialog>
  <div class="upload-loading" v-if="isUploadLoading" v-loading="isUploadLoading"></div>
</div>
</template>
<script>
import '@/styles/content.scss'
import MaterialSelector from '@/components/material-selector/MaterialSelector.vue'
import { materialType } from '@/const/crud/material/material'
import Editor from '@tinymce/tinymce-vue';
import tinymce from 'tinymce/tinymce';
// 解决图标显示!not found的问题
import 'tinymce/icons/default'
import {
  getOSSSign,
  getFileNameUUID,
  getOSSPost,
  getOSSVideoPost,
  getOSSFilePost,
  uploadOSSFile,
} from '@/api/basic/aliyunoss';
import { matchUrl } from '@/util/util';

export default {
  name: 'RichTextEditor',
  components: {
    editor: Editor,
    MaterialSelector,
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    maxChars: {
      type: Number,
      default: 0,
    },
    height: {
      type: Number,
      default: 300,
    },
    placeholder: {
      type: String,
      default: '输入内容...',
    },
    customId: {
      type: String,
      default: '',
    },
    customBars: {
      type: String,
      default: '',
    },
    limit: {
      type: Object,
      default() {
        return {
          imgMaxSize: 2,
          imgMaxSizeMsg: '上传图片大小不能超过',
          videoMaxSize: 500,
          videoMaxSizeMsg: '上传视频大小不能超过',
          videoMaxDuration: 2,
          videoMaxDurationMsg: '上传视频时长不能超过',
          fileMaxSize: 50,
          fileMaxSizeMsg: '上传文件大小不能超过',
        };
      },
      required: false,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    isBasicPage: {
      type: Boolean,
      default: false,
    },
    ossImageFolder: {
      type: String,
      default: getOSSPost(),
    },
    ossVideoFolder: {
      type: String,
      default: getOSSVideoPost(),
    },
    ossFileFolder: {
      type: String,
      default: getOSSFilePost(),
    },
    isShowVideo: {
      type: Boolean,
      default: true,
    },
    isShowCustomlink: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showMaterialImageSelector: false,
      showMaterialVideoSelector: false,
      showMaterialFileSelector: false,
      idIndex: 1,
      id: '',
      editor: null,
      content: '',
      isShowImgUpload: false,
      isShowVideoUpload: false,
      ossAction: '',
      imgUrl: '',
      videoUrl: '',
      characterCount: 0,
      isShowFileUpload: false,
      fileUrl: '',
      isShowAddLink: false,
      addLinkDialogTitle: '',
      link: {
        text: '',
        address: '',
        visitLimit: false,
        isEdit: false,
      },
      linkFormRules: {
        text: [
          { required: true, message: '请输入链接文本', trigger: 'change' },
        ],
        address: [
          { required: true, message: '请输入链接地址', trigger: 'change' },
        ],
        visitLimit: [
          { required: true, message: '请选择访问限制', trigger: 'change' },
        ],
      },
      selectedNode: '',
      isEditLink: false,
      isUploadLoading: false,
      defaultOptions: {
        base_url: process.env.NODE_ENV !== 'production' 
                  ? '/cdn/tinymce/5.2.1'
                  : `${process.env.VUE_APP_PUBLIC_PATH}cdn/tinymce/5.2.1`,
        convert_urls: false,
        language: 'zh_CN',
        suffix: '.min',
        branding: false,
        skin: 'mc',
        content_css: 'mc',
        min_height: this.height,
        height: this.height,
        menubar: false,
        statusbar: false,
        table_responsive_width: true,
        table_appearance_options: false,
        table_advtab: false,
        table_cell_advtab: false,
        table_row_advtab: false,
        table_toolbar: 'tableprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol | tabledelete',
        plugins: [
          'lists',
          'wordcount',
          'paste',
          'autoresize',
          'autolink',
          'table',
          'preview',
          'searchreplace',
          'directionality',
          'visualblocks',
          'visualchars',
          'fullscreen',
          'template',
          'code',
          'codesample',
          'charmap',
          'hr',
          'nonbreaking',
          'insertdatetime',
          'advlist',
          'imagetools',
          'textpattern',
          'autosave',
          this.isBasicPage ? 'lineheight' : '',
        ],
        toolbar1: [
          'customundo customredo',
          'fontsizeselect',
          'formatselect',
          'styleselect',
          'fontselect',
          this.isBasicPage ? 'lineheight' : '',
          `bold italic underline ${this.customBars}`,
          'forecolor',
          'customimage custommedia',
          'bullist numlist',
          'alignleft aligncenter alignright alignjustify outdent indent formatpainter',
          'blockquote subscript superscript removeformat',
          'customlink table',
          'code undo redo restoredraft',
          'cut copy paste pastetext',
          'backcolor strikethrough codesample',
          'fullscreen preview',
          'charmap hr pagebreak insertdatetime',
        ].join(' | '),
        block_formats: '一级目录=h1; 二级目录=h2; 正文=p;',
        fontsize_formats: this.isBasicPage ? '8px 10px 12px 14px 16px 18px 20px 22px 24px 26px 28px 30px 32px' : '16px 18px 20px',
        contextmenu: false,
        placeholder: this.placeholder,
        invalid_elements: 'iframe,audio,embed,object,style,script',
        extended_valid_elements: 'video[id|src|class|style|controls|x5-video-player-type],i[class]',
        custom_colors: false,
        formats: {
          h1: { block: 'h1', styles: { fontSize: '20px', color: '#01396B' } },
          h2: { block: 'h2', styles: { fontSize: '18px', color: '#01396B' } },
          p: { block: 'p', styles: { fontSize: '16px', color: '#000000' } },
        },
        // color_map: [
        //   '#01396B', '主色',
        //   '#000', '黑色',
        //   '#999', '灰色',
        // ],
        paste_preprocess: (plugin, args) => {
          args.content = args.content.replace(/<(iframe|video|embed|object|style|script)[^>]*>/g, '');
          // 过滤sup,sub标签
          args.content = args.content.replace(/<(?!\/)(sup\b|sub\b)[^>]*>/g, '');
          args.content = args.content.replace(/<(\/)(sup\b|sub\b)[^>]*>/g, '');
          // b标签替换为strong标签
          args.content = args.content.replace(/<(?!\/)(b\b)[^>]*>/g, '<strong>');
          args.content = args.content.replace(/<(\/)(b\b)[^>]*>/g, '</strong>');
          // 将除了h1,h2,p,a,span,strong,em,img,以及表格相关标签以外的标签替换成p标签
          args.content = args.content.replace(/<(?!\/)(?!h1\b|h2\b|p\b|a\b|span\b|strong\b|em\b|img\b|table\b|thead\b|tbody\b|tfoot\b|th\b|tr\b|td\b|col\b)[^>]*>/g, '<p>');
          args.content = args.content.replace(/<(\/)(?!h1\b|h2\b|p\b|a\b|span\b|strong\b|em\b|img\b|table\b|thead\b|tbody\b|tfoot\b|th\b|tr\b|td\b|col\b)[^>]*>/g, '</p>');
        },
        paste_postprocess: (plugin, args) => {
          args.node.querySelectorAll('h1').forEach((item) => {
            item.setAttribute('style', 'font-size: 20px; color: #01396B;');
          });
          args.node.querySelectorAll('h2').forEach((item) => {
            item.setAttribute('style', 'font-size: 18px; color: #01396B;');
          });
          args.node.querySelectorAll('p').forEach((item) => {
            item.removeAttribute('style');
          });
          args.node.querySelectorAll('span').forEach((item) => {
            item.removeAttribute('style');
          });
          args.node.querySelectorAll('img').forEach((item) => {
            if (item.src.indexOf(this.ossAction) !== 0) {
              item.parentNode.removeChild(item);
            }
          });
          args.node.querySelectorAll('table').forEach((item) => {
            item.setAttribute('style', 'border-collapse: collapse;');
          });
          args.node.querySelectorAll('td,th').forEach((item) => {
            item.setAttribute('style', 'border: 1px solid #999;');
          });
        },
        setup: (editor) => {
          editor.ui.registry.addIcon(
            'customimage',
            `
            <svg width="20" height="17" viewBox="0 0 14 13">
              <g fill-rule="nonzero">
                <path d="M11.4 0H2.5A2.5 2.5 0 000 2.5v7.2c0 1.4 1.1 2.5 2.5 2.5h9c1.3 0 2.4-1.1 2.4-2.5V2.5C14 1.1 12.8 0 11.4 0zM2.5.7h9c.9 0 1.7.8 1.7 1.8V4L9 8 5.5 3.8l-4.8 4V2.5c0-1 .8-1.8 1.8-1.8z"></path><path d="M9.9 5.2a1.6 1.6 0 100-3.1 1.6 1.6 0 000 3.1z"></path>
              </g>
            </svg>
            `,
          );
          editor.ui.registry.addIcon(
            'custommedia',
            `
            <svg width="20" height="17" viewBox="0 0 16 11">
              <path d="M15.7.5c.2.3.3.6.3 1v7.3c0 .4 0 .7-.3 1-.2.3-.6.5-1 .5s-.7-.1-1-.4l-2.4-1.8a2 2 0 01-2 2H2c-1.1 0-2-.9-2-2v-6C0 1.1.9.2 2 .2h7.4c1 0 2 .9 2 1.9v.1L13.6.4c.7-.6 1.6-.5 2 .1zm-8.3.6a1.7 1.7 0 100 3.5 1.7 1.7 0 000-3.5z" fill-rule="nonzero"/>
            </svg>
            `,
          );
          editor.ui.registry.addIcon(
            'customupload',
            `
            <svg t="1604060043188" class="icon" viewBox="0 0 1398 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="17387" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20"><defs><style type="text/css"></style></defs>
              <path d="M1398.247795 74.020529v725.401186a74.020529 74.020529 0 0 1-74.020529 74.020529H1273.153101v-56.995808a64.990025 64.990025 0 0 0 59.216423-63.953737V120.949545a65.434148 65.434148 0 0 0-66.026312-64.397861H317.696111a65.878271
                65.878271 0 0 0-63.805696 48.409426h-67.506723V74.020529a74.020529 74.020529 0 0 1 74.020529-74.020529h1063.971086a74.020529 74.020529 0 0 1 73.872488 74.020529z" p-id="17388">
              </path>
              <path d="M1211.716062 309.701894v640.277577a74.020529 74.020529 0 0 1-74.020529 74.020529H74.020529a74.020529 74.020529 0 0 1-74.020529-74.020529v-725.401186a74.020529 74.020529 0 0 1 74.020529-74.020529h345.083707v159.144138z" p-id="17389"></path>
            </svg>
            `,
          );
          editor.ui.registry.addIcon(
            'customundo',
            `
            <svg class="icon" width="20px" height="20.00px" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
              <path d="M474.825697 133.492364a31.030303 31.030303 0 0 1 8.998788 21.845333v172.094061C743.175758 350.642424 946.424242 566.613333 946.424242 829.657212c0 9.309091-0.558545 20.200727-1.675636 32.643879l-0.930909
                9.619394a31.030303 31.030303 0 0 1-53.837576 17.625212 563.603394 563.603394 0 0 0-42.418424-42.821818 617.130667 617.130667 0 0 0-363.737212-152.917334v168.370425a31.030303 31.030303 0 0 1-52.906667 22.031515L96.504242
                552.835879a62.060606 62.060606 0 0 1-0.403394-87.753697l0.403394-0.403394 334.413576-331.403636a31.030303 31.030303 0 0 1 43.907879 0.217212z" />
            </svg>
            `,
          );
          editor.ui.registry.addIcon(
            'customredo',
            `
            <svg class="icon" width="20px" height="20.00px" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
              <path d="M549.174303 133.492364a31.030303 31.030303 0 0 0-8.998788 21.845333v172.094061C280.824242 350.642424 77.575758 566.613333 77.575758 829.657212c0 9.309091 0.558545 20.200727 1.675636 32.643879l0.930909
                9.619394a31.030303 31.030303 0 0 0 53.837576 17.625212c16.446061-18.121697 30.595879-32.395636 42.418424-42.821818a617.130667 617.130667 0 0 1 363.737212-152.917334v168.370425a31.030303 31.030303 0 0 0
                52.906667 22.031515L927.495758 552.835879a62.060606 62.060606 0 0 0 0.403394-87.753697l-0.403394-0.403394-334.413576-331.403636a31.030303 31.030303 0 0 0-43.907879 0.217212z" />
            </svg>
            `,
          );
          editor.ui.registry.addButton('customimage', {
            icon: 'customimage',
            tooltip: '添加图片',
            onAction: () => {
              this.isShowImgUpload = true;
              this.imgUrl = '';
            },
          });
          if (this.isShowVideo) {
            editor.ui.registry.addButton('custommedia', {
              icon: 'custommedia',
              tooltip: '添加视频',
              onAction: () => {
                this.isShowVideoUpload = true;
                this.videoUrl = '';
              },
            });
          }
          editor.ui.registry.addButton('customupload', {
            icon: 'customupload',
            tooltip: '上传文件',
            onAction: () => {
              this.isShowFileUpload = true;
              this.fileUrl = '';
            },
          });
          editor.ui.registry.addIcon(
            'customlink',
            `
            <svg class="icon" width="19px" height="19px" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
              <path d="M742.453 64c83.117 4.859 158.046 45.887 196.824 137.12 39.395 92.698 21.86 178.919-46.116 252.568-48.125 52.056-99.802 100.874-150.321 150.693-21.938 21.671-57.085 22.365-76.088 2.391-19.234-20.206-17.148-47.969
                5.948-71.182 49.592-49.743 99.88-98.868 148.93-149.073 73.925-75.655 41.096-195.963-61.024-223.11-42.485-11.259-83.271-3.47-115.56 26.607-51.987 48.355-100.884 99.871-152.639 148.303-10.968 10.257-29.121 19.125-43.335
                18.2-38.082-2.314-57.316-48.432-30.975-75.886 56.621-58.997 114.401-117.069 175.194-171.67C630.292 75.722 678.494 64.308 742.453 64zM64 729.779c0.386-63.624 22.556-118.611 67.127-163.958 49.206-50.128 99.184-99.485
                149.085-148.919 23.715-23.522 52.837-25.295 72.92-5.09 20.857 21.054 18.849 47.583-5.87 72.416-47.507 47.66-95.785 94.704-142.828 142.904-58.167 59.46-60.639 139.741-7.03 193.649 51.292 51.593 136.108 51.824 189.717-0.386
                48.742-47.506 96.171-96.4 144.76-143.984 29.198-28.534 73.538-18.354 81.262 20.052 2.781 13.804-2.78 34.627-12.36 44.73-52.835 55.68-105.595 111.824-163.143 162.337-70.449 61.85-153.025 72.108-239.077 34.627C115.369 901.911
                64.232 820.241 64 729.78z m644.542-362.85c-3.09 5.783-6.643 18.277-14.676 26.451a45590.165 45590.165 0 0 1-292.068 293.828c-20.78 20.746-50.365 19.357-69.908-0.385-19.698-19.897-19.157-47.198 2.78-69.254 96.018-96.246
                192.344-192.26 288.593-288.198 15.603-15.579 33.91-22.134 55.23-12.88 19.003 8.252 28.659 23.368 30.05 50.437z" />
            </svg>
            `,
          );
          if (this.isShowCustomlink) {
            editor.ui.registry.addButton('customlink', {
              icon: 'customlink',
              tooltip: '添加/编辑超链接',
              onAction: () => {
                this.isShowAddLink = true;
                this.addLinkDialogTitle = '添加超链接';
                this.link = {
                  text: '',
                  address: '',
                  visitLimit: false,
                  isEdit: false,
                };
                this.selectedNode = tinymce.activeEditor.selection.getNode();
                if (this.selectedNode.tagName === 'A' && this.selectedNode.className.indexOf('mc-link') !== -1) {
                  this.addLinkDialogTitle = '编辑超链接';
                  this.link.isEdit = true;
                  this.link.text = this.selectedNode.innerText;
                  this.link.address = this.selectedNode.href;
                  if (this.selectedNode.className.indexOf('visit-limit') !== -1) {
                    this.link.visitLimit = true;
                  }
                }
              } ,
            });
          }
          editor.ui.registry.addButton('customundo', {
            icon: 'customundo',
            tooltip: '撤销',
            onAction: () => {
              this.undo();
            },
          });
          editor.ui.registry.addButton('customredo', {
            icon: 'customredo',
            tooltip: '重做',
            onAction: () => {
              this.redo();
            },
          });
        },
        init_instance_callback: (editor) => {
          // 重写快捷键,meta在windows系统上为ctrl键,mac系统上为cmd键
          editor.addShortcut('meta+z', '撤销', () => {
            const scrollWrap = document.querySelector('.avue-main .el-scrollbar__wrap');
            const scrollTop = scrollWrap.scrollTop; // 滚动条偏移量
            if (this.undo()) {
              // 阻止滚动条跳到编辑器最顶端
              scrollWrap.scrollTop = scrollTop;
            }
          });
          editor.addShortcut('meta+y', '重做', () => {
            const scrollWrap = document.querySelector('.avue-main .el-scrollbar__wrap');
            const scrollTop = scrollWrap.scrollTop;
            if (this.redo()) {
              scrollWrap.scrollTop = scrollTop;
            }
          });
          editor.addShortcut('meta+shift+z', '重做', () => {
            const scrollWrap = document.querySelector('.avue-main .el-scrollbar__wrap');
            const scrollTop = scrollWrap.scrollTop;
            if (this.redo()) {
              scrollWrap.scrollTop = scrollTop;
            }
          });
          //处理全屏时被菜单栏遮挡情况
          editor.on('FullscreenStateChanged', function(data){
            const menu = document.querySelector('.avue-left');
            if(data.state){
                menu.setAttribute("style", "z-index:0;");
            } else {
                menu.setAttribute("style", "z-index:1025;");
            }
          });
        },
      },
    };
  },
  computed: {
    imgLimit() {
      return this.limit;
    },
  },
  watch: {
    value(value) {
      this.content = value;
    },
    content(value) {
      this.getCharacterCount();
      this.$emit('input', value);
    },
    editor() {
      this.getCharacterCount();
    },
    editable(value) {
      if (!this.editor) {
        return;
      }
      if (!value) {
        this.editor.mode.set('readonly');
      } else {
        this.editor.mode.set('design');
      }
    },
  },
  created() {
    this.content = this.value;
    this.getRandomId();
    this.getOssAction();
  },
  mounted() {
    // const scrollWrap = document.querySelector('.avue-main .el-scrollbar__wrap');
    // scrollWrap.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    // const scrollWrap = document.querySelector('.avue-main .el-scrollbar__wrap');
    // scrollWrap.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleMaterialImageSelectorClose () {
      this.showMaterialImageSelector = false;
    },
    handleMaterialVideoSelectorClose () {
      this.showMaterialVideoSelector = false;
    },
    handleMaterialFileSelectorClose () {
      this.showMaterialFileSelector = false;
    },
    handleConfirmImageSelect (materialList) {
      this.showMaterialImageSelector = false;
      this.isShowImgUpload = false;
      for (const material of materialList) {
        this.imgUrl = material.contentUrl;
        if (this.imgUrl) {
          window.tinyMCE.execCommand('mceInsertContent', false, `<p><img class="mc-img" src="${this.imgUrl}"/></p><br/>`);
        }
        this.imgUrl = '';
      }
    },
    handleConfirmVideoSelect (materialList) {
      this.showMaterialVideoSelector = false;
      this.isShowVideoUpload = false;
      for (const material of materialList) {
        this.videoUrl = material.contentUrl;
        if (this.videoUrl) {
          window.tinyMCE.execCommand('mceInsertContent', false, `<p><span contenteditable="false" style="display:block;cursor:default;"><video src="${this.videoUrl}" style="width:100%;max-height:390px;border-radius:8px;outline:none;" x5-video-player-type="h5-page" controls></video></span></p><br/>`);
        }
        this.videoUrl = '';
      }
    },
    handleConfirmFileSelect (materialList) {
      this.showMaterialFileSelector = false;
      this.isShowFileUpload = false;
      for (const material of materialList) {
        if (material.type === materialType.PICTURE) {
          this.imgUrl = material.contentUrl;
          if (this.imgUrl) {
            window.tinyMCE.execCommand('mceInsertContent', false, `<p><img class="mc-img" src="${this.imgUrl}"/></p><br/>`);
          }
          this.imgUrl = '';
        } else if (material.type === materialType.VIDEO) {
          this.videoUrl = material.contentUrl;
          if (this.videoUrl) {
            window.tinyMCE.execCommand('mceInsertContent', false, `<p><span contenteditable="false" style="display:block;cursor:default;"><video src="${this.videoUrl}" style="width:100%;max-height:390px;border-radius:8px;outline:none;" x5-video-player-type="h5-page" controls></video></span></p><br/>`);
          }
          this.videoUrl = '';
        } else {
          this.fileUrl = material.contentUrl;
          if (this.fileUrl) {
            window.tinyMCE.execCommand('mceInsertContent', false, `
              <p contenteditable="false">
                <a class="mc-file" href="${this.fileUrl}" download="${material.name}" target="_blank">
                  <i class="mc-file-icon"></i>${material.name}
                </a>
              </p>
              <br/>
            `);
          }
          this.fileUrl = '';
        }
      }
    },
    onInit(e, editor) {
      this.editor = editor;
      if (!this.editable) {
        this.editor.mode.set('readonly');
      } else {
        this.editor.mode.set('design');
      }

      this.$nextTick(() => {
        const parent = tinymce.$(`#${this.id}`).parent()[0];
        if (parent) {
          const buttons = tinymce.$('.tox-statusbar__wordcount', parent);
          if (buttons[0]) {
            buttons[0].click();
          }
        }

        editor.getDoc().addEventListener('click', this.onClick);
      });
    },
    onKeyDown(e) {
      if (e.keyCode !== 8 && e.keyCode !== 46
        && this.maxChars > 0 && this.characterCount >= this.maxChars) {
        return false;
      }

      return true;
    },
    onClick(e) {
      if (!this.editable) {
        this.editor.mode.set('readonly');
        this.$message({
          message: '请先选择供需类别和主题',
          type: 'warning',
        });
      } else {
        this.editor.mode.set('design');
      }
    },
    onPaste(e) {
      if (!(e.clipboardData && e.clipboardData.items)) {
        return;
      }
      const text = e.clipboardData.getData('text/html') || '';
      let imgUrl;
      text.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/, (match, capture) => {
        imgUrl = capture;
      });
      // 已存在于oss的图片不再上传
      if (imgUrl && imgUrl.indexOf(this.ossAction) === 0) {
        return;
      }
      for (let i = 0, len = e.clipboardData.items.length; i < len; i += 1) {
        const item = e.clipboardData.items[i];
        if (item.kind === 'file') {
          const file = item.getAsFile();
          // 将外部网站的图片上传到oss
          if (this.beforeImageUpload(file)) {
            this.uploadPastedFile(file);
          }
        }
      }
    },
    onDrop(e) {
      // 阻止浏览器默认打开文件的操作
      e.preventDefault();
      const files = e.dataTransfer.files;
      for (let i = 0; i < files.length; i += 1) {
        if (this.beforeImageUpload(files[i])) {
          this.uploadPastedFile(files[i]);
        }
      }
    },
    onBlur(e) {
      this.$emit('onblur');
    },
    getRandomId() {
      this.id = `editor-${this.idIndex}-${Math.floor(Math.random() * 100)}`;
      this.idIndex += 1;
    },
    getCharacterCount() {
      this.$nextTick(() => {
        if (!this.editor) {
          return;
        }

        const wordCounter = this.editor.plugins.wordcount;
        this.characterCount = wordCounter.body.getCharacterCount();
        this.$emit('getContentLength', this.characterCount);
      });
    },
    cancelImageUpload() {
      this.isShowImgUpload = false;
      this.imgUrl = '';
      this.$refs.imgUpload.clearFiles();
    },
    cancelVideoUpload() {
      this.isShowVideoUpload = false;
      this.videoUrl = '';
      this.$refs.videoUpload.clearFiles();
    },
    cancelFileUpload() {
      this.isShowFileUpload = false;
      this.fileUrl = '';
      this.$refs.fileUpload.clearFiles();
    },
    handleImgChange(file, fileList) {
      if (file.status === 'success' || file.status === 'fail') {
        const index = fileList.indexOf(file);
        fileList.splice(index, 1);
      }
    },
    handleImgUploadSuccess(response, file, fileList) {
      const { raw } = file;
      const { config } = response;
      if (raw && config) {
        this.imgUrl = `${config.url}/${raw.key}`;
        if (this.imgUrl) {
          window.tinyMCE.execCommand('mceInsertContent', false, `<p><img class="mc-img" src="${this.imgUrl}"/></p><br/>`);
        }
        this.imgUrl = '';
        // this.$refs.imgUpload.clearFiles();
      }
    },
    handleVideoUploadSuccess(response, file, fileList) {
      const { raw } = file;
      const { config } = response;
      if (raw && config) {
        this.videoUrl = `${config.url}/${raw.key}`;
        if (this.videoUrl) {
          window.tinyMCE.execCommand('mceInsertContent', false, `<p><span contenteditable="false" style="display:block;cursor:default;"><video src="${this.videoUrl}" style="width:100%;max-height:390px;border-radius:8px;outline:none;" x5-video-player-type="h5-page" controls></video></span></p><br/>`);
        }
        this.videoUrl = '';
        this.$refs.videoUpload.clearFiles();
      }
    },
    handleFileUploadSuccess(response, file, fileList) {
      const { raw } = file;
      const { config } = response;
      if (raw && config) {
        this.fileUrl = `${raw.key}`;
        if (this.fileUrl) {
          window.tinyMCE.execCommand('mceInsertContent', false, `
            <p contenteditable="false">
              <a class="mc-file" href="${this.fileUrl}" download="${raw.name}" target="_blank">
                <i class="mc-file-icon"></i>${raw.name}
              </a>
            </p>
            <br/>
          `);
        }
        this.fileUrl = '';
        this.$refs.fileUpload.clearFiles();
      }
    },
    beforeImageUpload(file) {
      let suffix = '';
      const imgMaxSize = this.limit.imgMaxSize || 2;
      const imgMaxSizeMsg = this.limit.imgMaxSizeMsg || '上传图片大小不能超过';
      const imageType = file.type ? file.type.toLowerCase() : '';
      const isLt15M = file.size ? file.size / 1024 / 1024 < imgMaxSize : false;

      if (imageType === 'image/jpeg') {
        suffix = '.jpg';
      } else if (imageType === 'image/png') {
        suffix = '.png';
      } else if (imageType === 'image/gif') {
        suffix = '.gif';
      } else {
        this.$message({
          message: '仅支持jpg、png、gif类型图片',
          type: 'error',
        });
        return false;
      }
      if (!isLt15M) {
        this.$message({
          message: `${imgMaxSizeMsg} ${imgMaxSize}MB!`,
          type: 'error',
        });        return false;
      }

      file.key = this.ossImageFolder + getFileNameUUID() + suffix;
      this.isShowImgUpload = false;
      return true;
    },
    beforeVideoUpload(file) {
      let suffix = '';
      const videoMaxSize = this.limit.videoMaxSize || 500;
      const videoMaxSizeMsg = this.limit.videoMaxSizeMsg || '上传视频大小不能超过';
      const videoType = file.type ? file.type.toLowerCase() : '';
      const isLt500M = file.size ? file.size / 1024 / 1024 < videoMaxSize : false;

      if (videoType.indexOf('video') !== -1) {
        const index = videoType.indexOf('/') + 1;
        suffix = `.${videoType.substring(index)}`;
      } else {
        this.$message({
          message: '仅支持上传视频',
          type: 'error',
        });
        return false;
      }

      if (!isLt500M) {
        this.$message({
          message: `${videoMaxSizeMsg} ${videoMaxSize}MB!`,
          type: 'error',
        });
        return false;
      }

      file.key = this.ossVideoFolder + getFileNameUUID() + suffix;
      this.isShowVideoUpload = false;
      return true;
    },
    beforeFileUpload(file) {
      let suffix = '';
      const fileMaxSize = this.limit.fileMaxSize || 50;
      const fileMaxSizeMsg = this.limit.fileMaxSizeMsg || '上传文件大小不能超过';
      const isLt50M = file.size ? file.size / 1024 / 1024 < fileMaxSize : false;
      const index = file.name.lastIndexOf('.');
      suffix = file.name.substring(index).toLowerCase();

      if (!isLt50M) {
        this.$message({
          message: `${fileMaxSizeMsg} ${fileMaxSize}MB`,
          type: 'error',
        });
        return false;
      }

      file.key = this.ossFileFolder + getFileNameUUID() + suffix;
      this.isShowFileUpload = false;
      return true;
    },
    uploadFile(option) {
      getOSSSign().then((response) => {
        const flash = '/';
        const ossFormData = new FormData();
        ossFormData.append('key', option.file.key);
        ossFormData.append('signature', response.data.data.signature);
        ossFormData.append('policy', response.data.data.policy);
        ossFormData.append('OSSAccessKeyId', response.data.data.accessKeyId);
        ossFormData.append('success_action_status', '200');
        ossFormData.append('file', option.file);
        this.ossAction = response.data.data.host;
        let cdnHost = response.data.data.cdnHost
        this.isUploadLoading = true;
        uploadOSSFile(this.ossAction, ossFormData).then((resp) => {
          console.log('uploadFile - OK', resp);
          option.onSuccess(resp);
        }).catch((err) => {
          console.log(err);
          this.$message({
            showClose: true,
            message: '文件上传失败',
            type: 'error',
          });
          option.onError(err);
        }).finally(() => {
          this.isUploadLoading = false;
        });
      }).catch((error) => {
        console.log(error);
        this.$message({
          showClose: true,
          message: '文件上传失败',
          type: 'error',
        });
        option.onError(error);
      });
    },
    getOssAction() {
      getOSSSign().then((response) => {
        this.ossAction = response.data.data.host;
      });
    },
    afterCloseAddLinkDialog() {
      this.$refs.linkForm.resetFields();
      this.selectedNode = '';
    },
    closeAddLinkDialog() {
      this.isShowAddLink = false;
    },
    handleAddLink() {
      this.$refs.linkForm.validate((valid) => {
        if (!valid) {
          return false;
        }

        if (!matchUrl(this.link.address)) {
          this.link.address = `https://${this.link.address}`;
        }

        if (this.link.isEdit) {
          this.selectedNode.remove();
        }

        window.tinyMCE.execCommand('mceInsertContent', false,
          `<a class="${this.link.visitLimit ? 'mc-link visit-limit' : 'mc-link'}" href="${this.link.address}" target="_blank">${this.link.text}</a>`);
        this.closeAddLinkDialog();
        return true;
      });
    },
    uploadPastedFile(file) {
      getOSSSign().then((response) => {
        const flash = '/';
        const ossFormData = new FormData();
        ossFormData.append('key', file.key);
        ossFormData.append('signature', response.data.data.signature);
        ossFormData.append('policy', response.data.data.policy);
        ossFormData.append('OSSAccessKeyId', response.data.data.accessKeyId);
        ossFormData.append('success_action_status', '200');
        ossFormData.append('file', file);
        this.ossAction = response.data.data.host;
        this.isUploadLoading = true;
        uploadOSSFile(this.ossAction, ossFormData).then((resp) => {
          console.log('uploadFile - OK', resp);
          this.handleImgUploadSuccess(resp, { raw: file });
        }).catch((err) => {
          console.log(err);
          this.$message({
            showClose: true,
            message: '文件上传失败',
            type: 'error',
          });
        }).finally(() => {
          this.isUploadLoading = false;
        });
      }).catch((error) => {
        console.log(error);
        this.$message({
          showClose: true,
          message: '文件上传失败',
          type: 'error',
        });
      });
    },
    handleScroll(e) {
      const toolbar = document.querySelector('.tox-editor-header');
      const editorContainer = document.querySelector('.tox-editor-container');
      if (!editorContainer) return;
      const top = editorContainer.getBoundingClientRect().top;
      if (top < 114) {
        const width =  window.getComputedStyle(editorContainer).width;
        const toolbarHeight = window.getComputedStyle(toolbar).height;
        toolbar.style.cssText = `position:fixed;top:114px;width:${width};box-shadow:0 4px 4px -3px rgba(0,0,0,.25);`;
        editorContainer.style.paddingTop = `${toolbarHeight}`;
      } else {
        toolbar.style.cssText = '';
        editorContainer.style.paddingTop = '';
      }
    },
    undo() {
      if (!this.editor.undoManager.hasUndo()) {
        this.$message({
          type: 'warning',
          message: '没有内容可以撤销',
        });
        return false;
      }
      this.editor.undoManager.undo();
      return true;
    },
    redo() {
      if (!this.editor.undoManager.hasRedo()) {
        this.$message({
          type: 'warning',
          message: '没有内容可以重做',
        });
        return false;
      }
      this.editor.undoManager.redo();
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.rich-text-editor {
  position: relative;
  .number-word-tip {
    position: absolute;
    bottom: 8px;
    right: 18px;
    font-size: 16px;
    color: #D8D8D8;
    letter-spacing: 0;
    text-align: right;
    line-height: 24px;
    .out-of-limit {
      color: red;
    }
  }
  .upload-loading {
    position: fixed !important;
    top: 0;
    left: 0;
    z-index: 2999;
    width: 100vw;
    min-height: 100vh;
  }
}
/deep/ .el-dialog__wrapper {
  text-align: center;
  .dialog {
    height: 250px;
    border-radius: 8px;
    .el-dialog__header{
      padding-top: 38px;
      .el-dialog__title {
        font-size: 16px;
        font-weight: bold;
        color: #333333;
        letter-spacing: 0;
      }
    }
    .el-dialog__body {
      .dialog-tip {
        font-size: 14px;
        color: #999999;
        letter-spacing: 0;
        text-align: center;
      }
      .icon-close {
        background-image: url(../../static/images/editor/close.png);
        display: inline-block;
        width: 32px;
        height: 32px;
        position: absolute;
        top: -40px;
        right: -10px;
        cursor: pointer;
      }
    }
    .el-dialog__footer {
      text-align: center;
      .dialog-select {
        width: 330px;
        height: 45px;
        background: #005FB4;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0;
        border: none;
      }
    }
  }
  .add-link-dialog {
    height: auto;
    padding: 16px 19px 32px;
    .el-dialog__header {
      padding: 0 0 26px;
    }
    .el-dialog__body {
      padding: 0;
      .el-form-item {
        margin: 0;
        .link-text {
          .el-input__inner {
            border-radius: 4px 4px 0 0;
            border: 1px solid #EEEEEE;
            border-bottom: 0;
          }
          .el-input__inner::placeholder {
            color: #999;
          }
        }
        .el-form-item__error {
          z-index: 1;
          left: auto;
          right: 5px;
        }
        .link-address {
          .el-textarea__inner {
            border-radius: 0 0 4px 4px;
            resize:none;
            border: 1px solid #EEEEEE;
          }
          .el-textarea__inner::placeholder {
            color: #999;
          }
        }
      }
      .el-form-item.visit-limit {
        margin-top: 5px;
        text-align: left;
        .visit-limit-label {
          margin-right: 30px;
          font-size: 15px;
        }
        .el-radio {
          .el-radio__label {
            font-size: 15px;
          }
        }
      }
    }
    .el-dialog__footer {
      margin-top: 26px;
      padding: 0;
    }
  }
}
</style>

<style lang="scss">
.tox {
  .tox-editor-container {
    .tox-editor-header {
      .tox-toolbar-overlord {
        .tox-toolbar__primary {
          display: flex;
          justify-content: center;
        }
      }
    }
    .tox-sidebar-wrap {
      background: #F6F6F6;
      .tox-edit-area {
        margin: 0 0;
      }
    }
  }
}
.tox-tinymce-aux {
  z-index: 3000 !important;
  .tox-menu {
    .tox-collection__group {
      .tox-collection__item[title="单元格属性"],
      .tox-collection__item[title="行属性"],
      .tox-collection__item[title="剪切行"],
      .tox-collection__item[title="复制行"],
      .tox-collection__item[title="粘贴到上方"],
      .tox-collection__item[title="粘贴到下方"] {
        display: none;
      }
    }
  }
  .tox-dialog-wrap {
    align-items: flex-start !important;
    .tox-dialog-wrap__backdrop {
      opacity: 0.5;
      background: #000000;
    }
    .tox-dialog {
      width: 459px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
      border-radius: 8px;
      border: none;
      overflow: visible;
      height: 459px !important;
      margin-top: 114px !important;
      .tox-dialog__header {
        border-radius: 8px 8px 0 0;
        padding: 16px 19px 0;
        .tox-dialog__title {
          font-size: 16px;
          font-weight: bold;
          color: #333333;
          margin: 0 auto;
        }
        .tox-button:hover {
          background: none;
          color: #fff;
        }
        .tox-button {
          position: absolute;
          top: -40px;
          right: -10px;
          border-radius: 50%;
          border: 2px solid #fff;
          color: #fff;
          padding: 2px;
        }
      }
      .tox-dialog__content-js {
        .tox-dialog__body-content {
          padding: 26px 19px 0;
          .tox-form {
            .tox-form__group {
              .tox-label {
                margin-bottom: 5px;
              }
              .tox-label,
              .tox-textfield,
              .tox-selectfield select {
                color: #606266;
              }
            }
            .tox-form__group:not(:last-child) {
              margin-bottom: 15px;
            }
          }
        }
      }
      .tox-dialog__footer {
        border: none;
        border-radius: 0 0 8px 8px;
        padding: 26px 19px 32px;
        justify-content: center;
        .tox-dialog__footer-end {
          .tox-button--secondary {
            display: none;
          }
          .tox-button {
            width: 330px;
            height: 45px;
            background: #005FB4;
            font-size: 14px;
            color: #ffffff;
            letter-spacing: 0;
            border: none;
            font-weight: 500;
            margin: 0;
          }
        }
      }
    }
  }
}
</style>
